class navigationTransition extends HTMLElement {
  constructor() {
    super();

    this.currentScrollTop = 0;
    this.links = this.querySelectorAll('[js-navigation="link"]');
    this.backdrop = this.querySelector('[js-navigation="backdrop"]');

    this.links.forEach((link) => {
      link.addEventListener('mouseenter', this.onLinkHover, false);
    });

    if (!this.classList.contains('header--no-transition')) {
      window.addEventListener('scroll', this.debounce(this.onScrollHandler, 200), false);
      this.addEventListener('mouseenter', this.onHoverHandler, false);
      this.addEventListener('mouseleave', this.onLeaveHandler, false);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  onScrollHandler = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 100) {
      this.classList.remove('header--transparent');
    } else {
      this.classList.add('header--transparent');
    }

    this.currentScrollTop = scrollTop;
  };

  onHoverHandler = () => {
    this.classList.add('header--override');
  };

  onLeaveHandler = () => {
    if (this.currentScrollTop > 100) {
      return;
    } else {
      this.classList.remove('header--override');
    }
  };

  onLinkHover = (e) => {
    const submenu = e.target.querySelector('[js-navigation="submenu"]');
    const submenuHeight = submenu.offsetHeight;
    this.backdrop.style.height = `${submenuHeight}px`;
  };

  bodyLock() {
    document.body.classList.add('body-locked');
  }

  bodyUnlock() {
    document.body.classList.remove('body-locked');
  }
}

customElements.define('navigation-transition', navigationTransition);
